module.exports = __webpack_public_path__ + "static/media/11d.27549e7c.png";